import { connect } from 'react-redux';
import { PreviewFooter } from '../../components/PreviewFooter/PreviewFooter';
import { IPreviewFooterEvents, IPreviewFooterField } from '../../components/PreviewFooter/types';
import { IApplicationState } from '../../../../../../../types/types';
import { IPreviewFooterHOCProps } from './types';
import { onReset } from './events/onReset';
import {
    getBoardDefaultCardPreviewHiddenProperties
} from '../../../../../../../store/model/board/selectors/getBoardDefaultCardPreviewHiddenProperties';
import {
    getBoardUserMetaCardPreviewHiddenProperties
} from '../../../../../../../store/model/board/selectors/getBoardUserMetaCardPreviewHiddenProperties';

const mapStateToProps = (
    state: IApplicationState,
    { boardId }: IPreviewFooterHOCProps
): IPreviewFooterField => {
    let isChanged ;
    const defaultProperties = getBoardDefaultCardPreviewHiddenProperties(state, boardId);
    const userProperties = getBoardUserMetaCardPreviewHiddenProperties(state, boardId);
    isChanged = defaultProperties.length !== userProperties.length;
    if (!isChanged) {
        for (let i = 0; i < userProperties.length; i++) {
            if (!defaultProperties.includes(userProperties[i])) {
                isChanged = true;
                break;
            }
        }
    }
    return {
        isChanged,
    };
};

const mapDispatchToProps = (
    dispatch: any,
    { boardId }: IPreviewFooterHOCProps
): IPreviewFooterEvents => {
    return {
        onReset: () => dispatch(onReset(boardId)),
    };
};

export const PreviewFooterHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(PreviewFooter);

PreviewFooterHOC.displayName = 'PreviewFooterHOC';
